// @flow

import styled from 'styled-components';
import { px, py } from 'styled-components-spacing';

import theme from '@theme';

export const StyledCover = styled.div`
  background: ${theme.colors.white};

  display: flex;
  flex-direction: row;

  ${px(3)}
  ${py(3)}
`;

export const StyledLabel = styled.p`
  flex: 1;
  font-weight: bold;
  color: ${theme.colors.darkBlue};
  font-size: 16px;

  ${({ isActive }) => isActive && `color: ${theme.colors.greyBlue}`}
`;

export const StyledSubLabel = styled.p`
  font-size: 16px;
  font-family: Raleway;
  color: ${theme.colors.gray};
`;
